import DateTimeFormatPart = Intl.DateTimeFormatPart;

const getDateParts = function (value: Date | number | string | undefined): DateTimeFormatPart[] {
    if (!value)
        return [];
    const d = new Date(value);
    const dtf = new Intl.DateTimeFormat('de', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    return dtf.formatToParts(d);
}

const resolveDelimters = function (str: string, dateDelimiter: string, timeDelimiter: string): string {
    return str.replace(new RegExp("delDate", "gi"), dateDelimiter)
        .replace(new RegExp("delTime", "gi"), timeDelimiter);
}

export const formatDateTime = function (value: Date | number | string | undefined, dateDelimiter?: string, timeDelimiter?: string, omitSeconds?: boolean): string {
    const [{value: da}, , {value: mo}, , {value: ye}, , {value: ho}, , {value: mi}, , {value: sec}] = getDateParts(value);
    return resolveDelimters(`${ye}delDate${mo}delDate${da} ${ho}delTime${mi}${omitSeconds ? "" : "delTime"}${omitSeconds ? "" : sec}`, dateDelimiter ?? ".", timeDelimiter ?? ":");
}

export const formatDate = function (value: Date | number | string | undefined, dateDelimiter?: string): string {
    const [{value: da}, , {value: mo}, , {value: ye}] = getDateParts(value);
    return resolveDelimters(`${ye}delDate${mo}delDate${da}`, dateDelimiter ?? ".", "");
}

export const formatTime = function (value: Date | number | string | undefined, timeDelimiter?: string, omitSeconds?: boolean): string {
    const [, , , , , , {value: ho}, , {value: mi}, , {value: sec}] = getDateParts(value);
    return resolveDelimters(`${ho}delTime${mi}${omitSeconds ? "" : "delTime"}${omitSeconds ? "" : sec}`, "", timeDelimiter ?? ":");
}

export function isDate(v: string): boolean {
    const date = new Date(v);
    return date instanceof Date && !isNaN(date.valueOf());
}